import Vue from 'vue'
import Router from 'vue-router'
import Novice from '@/components/novice'
import Question from '@/components/question'
import Introduce from '@/components/introduce'
import Answer from '@/components/answer'
import Supermember from '@/components/supermember'
import Announced from '@/components/announced'
import Essay from '@/components/essay'
import Peanut from '@/components/peanut'
import Download from '@/components/download'
import Others from '@/components/others'
import Test from '@/components/test'

Vue.use(Router)

export default new Router({
  // mode: 'history', // 访问路径不带井号
  // base: '/page/',  // 配置单页应用的基路径
  routes: [
    {
      path: '/novice',  //新手问题
      component: Novice
    },
    {
      path: '/question', //常见问题
      component: Question
    },
    {
      path: '/introduce',//规则说明
      component: Introduce
    },
    {
      path: '/answer', //问题答案页
      component: Answer
    },
    {
      path: '/supermember',//超级会员
      component: Supermember
    },
    {
      path: '/announced',//官方公告
      component: Announced
    },
    {
      path: '/essay',//花生圈
      component: Essay
    },
    {
      path: '/peanut',//花生圈
      component: Peanut
    },
    {
      path: '/download',//下载页
      component: Download
    },
    {
      path: '/others',//其他
      component: Others
    },
    {
      path: '/test',//其他
      component: Test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js